// A user photo. Unlike team and tournament logos it cannot be rendered from the
// document alone — users/ is private, so the bytes are fetched with a token and
// reach the DOM as a blob: URL. See utils/storageImage.

import { useStorageImage } from '../utils/storageImage';
import placeholderPerson from '../assets/images/placeholder-person.png';

export default function Avatar({ user, size = 64, className }) {
  const imgThumbUrl = useStorageImage(user?.imgThumbPath);

  return (
    <div
      className={`bg-image wh-${size}` + (className ? ' ' + className : '')}
      style={{ backgroundImage: `url(${imgThumbUrl || placeholderPerson})` }}
    />
  );
}
